export default __webpack_public_path__ + "static/media/chevron-right.bdef4ac0.svg";